
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacypolicy",
      function () {
        return require("private-next-pages/privacypolicy.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacypolicy"])
      });
    }
  